import lang from '@/lang'

/**
 * AG Grid column defs for article supplier assignment drawer (client-side list).
 * Matches design: Lieferanten-Nr., Name, Straße, PLZ, Ort, Telefon, Tags (+ checkbox from list-v2).
 */
export default {
  getColumns() {
    const labels = lang.article.editForm.labels
    return [
      {
        name: 'number',
        field: 'number',
        label: lang.transactionEdit.info.defaultLabels.supplierNumber,
        headerName: lang.transactionEdit.info.defaultLabels.supplierNumber,
        active: true,
        sort: false,
        width: 130,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'name',
        field: 'name',
        label: labels.assignSuppliersDrawer.columns.name,
        headerName: labels.assignSuppliersDrawer.columns.name,
        active: true,
        sort: 'asc',
        width: 180,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'street',
        field: 'street',
        label: labels.assignSuppliersDrawer.columns.street,
        headerName: labels.assignSuppliersDrawer.columns.street,
        active: true,
        sort: false,
        width: 160,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'zipCode',
        field: 'zipCode',
        label: labels.assignSuppliersDrawer.columns.zip,
        headerName: labels.assignSuppliersDrawer.columns.zip,
        active: true,
        sort: false,
        width: 90,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'city',
        field: 'city',
        label: labels.assignSuppliersDrawer.columns.city,
        headerName: labels.assignSuppliersDrawer.columns.city,
        active: true,
        sort: false,
        width: 130,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'phone',
        field: 'phone',
        label: labels.assignSuppliersDrawer.columns.phone,
        headerName: labels.assignSuppliersDrawer.columns.phone,
        active: true,
        sort: false,
        width: 140,
        suppressMovable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab'],
      },
      {
        name: 'tags',
        field: 'tags',
        label: labels.assignSuppliersDrawer.columns.tags,
        headerName: labels.assignSuppliersDrawer.columns.tags,
        active: true,
        sort: false,
        width: 160,
        suppressMovable: true,
        cellRenderer: 'tagCellRenderer',
        filter: false,
        menuTabs: ['filterMenuTab'],
      },
    ]
  },
}
